import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { UtilModule } from '@scaliolabs/baza-web-utils';

import { FooterLinksComponent } from './footer-links.component';

@NgModule({
    declarations: [FooterLinksComponent],
    exports: [FooterLinksComponent],
    imports: [CommonModule, NzMenuModule, RouterModule, UtilModule],
})
export class FooterLinksModule {}
